import {Component, Input, OnInit} from '@angular/core';
import {BenefitDetail} from "../../../../core/models/benefit-detail";
import {OrderDetails} from "../../../../core/models/order-details";

@Component({
  selector: 'app-benefit-details-card-payment-history',
  templateUrl: './benefit-details-card-payment-history.component.html',
  styleUrls: ['./benefit-details-card-payment-history.component.scss']
})
export class BenefitDetailsCardPaymentHistoryComponent implements OnInit {

  @Input() orderDetails: OrderDetails;
  constructor() { }

  ngOnInit(): void {
  }

}
